export default "__VITE_ASSET__BeAOloJN__"